module.exports = __webpack_public_path__ + "static/logo-large-white-f391b792ac06501b9e9369dcc2d9561a.png";